// After initial slide-in, trigger infinite loop animation
window.addEventListener('DOMContentLoaded', () => {
	const leftWrapper = document.querySelector(
		'.block-hero-standard__gallery-col--left .gallery-anim-wrapper'
	);
	const rightWrapper = document.querySelector(
		'.block-hero-standard__gallery-col--right .gallery-anim-wrapper'
	);
	if (leftWrapper) {
		leftWrapper.addEventListener('animationend', (e) => {
			if (e.animationName === 'slideInFromBottom') {
				leftWrapper.classList.add('is-looping');
			}
		});
	}
	if (rightWrapper) {
		rightWrapper.addEventListener('animationend', (e) => {
			if (e.animationName === 'slideInFromTop') {
				rightWrapper.classList.add('is-looping');
			}
		});
	}
});

function setGalleryHeight() {
	const galleries = document.querySelectorAll(
		'.block-hero-standard__gallery'
	);
	galleries.forEach((gallery) => {
		gallery.style.setProperty(
			'--galleryHeight',
			`${gallery.offsetHeight}px`
		);
		if (
			!gallery.classList.contains('block-hero-standard__gallery--ready')
		) {
			gallery.classList.add('block-hero-standard__gallery--ready');
		}
	});
}

function setGallerySizes() {
	document.querySelectorAll('.gallery-anim-wrapper').forEach((el) => {
		// Because content is duplicated, divide by 2
		const scrollSize = el.scrollWidth / 2;
		el.style.setProperty('--scrollSize', `${scrollSize}px`);
	});
}

function handleGalleryResponsive() {
	if (window.matchMedia('(min-width: 768px)').matches) {
		setGalleryHeight();
	} else {
		setGallerySizes();
	}
}

let resizeTimeout;
function onResize() {
	clearTimeout(resizeTimeout);
	resizeTimeout = setTimeout(handleGalleryResponsive, 100);
}

window.addEventListener('load', handleGalleryResponsive);
window.addEventListener('resize', onResize);
